import styled from 'styled-components';
import { Table } from 'antd';
import { onPhone } from '../../theme/tokens';

export const Columns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  align-items: start;
  > div {
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-width: 0;
  }
  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const HeadText = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  ${onPhone} {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }
`;

export const StackTable = styled(Table)`
  ${onPhone} {
    .ant-table-thead,
    .ant-table-measure-row,
    colgroup {
      display: none;
    }
    table {
      display: block;
      width: 100% !important;
      min-width: 0 !important;
    }
    .ant-table-tbody {
      display: block;
    }
    .ant-table-tbody > tr.ant-table-row {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px 12px;
      padding: 12px 0;
      border-bottom: 1px solid #f0f0f0;
    }
    .ant-table-tbody > tr.ant-table-row > td {
      display: block;
      flex: 1 1 40%;
      min-width: 0;
      padding: 0;
      border: 0;
      order: 2;
    }
    .ant-table-tbody > tr.ant-table-row > td:first-child {
      flex: 1 1 calc(100% - 64px);
      order: 0;
    }
    .ant-table-tbody > tr.ant-table-row > td:last-child {
      flex: none;
      order: 1;
    }
    .ant-select {
      width: 100% !important;
    }
  }
`;

export const TableCard = styled.section`
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  header {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 10px;
    padding: 16px 20px 12px;
  }
  h2 {
    margin: 0;
    font-size: 16px;
    font-weight: 700;
    color: #262626;
  }
  header span {
    font-size: 13px;
    color: #8c8c8c;
  }
  .scroll {
    overflow-x: auto;
  }
  table {
    display: block;
    width: 100%;
    min-width: 720px;
    font-size: 13px;
  }
  thead,
  tbody {
    display: block;
  }
  tr {
    display: grid;
    grid-template-columns: var(--grid);
    align-items: start;
    border-bottom: 1px solid #f0f0f0;
  }
  thead tr {
    background: #fafafa;
  }
  th,
  td {
    display: block;
    min-width: 0;
  }
  th {
    text-align: left;
    padding: 10px 12px;
    font-family: 'Montserrat', sans-serif;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #8c8c8c;
    white-space: nowrap;
  }
  td {
    padding: 13px 12px;
    color: #595959;
  }
  th:first-child,
  th:last-child,
  td:first-child,
  td:last-child {
    padding-left: 20px;
    padding-right: 20px;
  }
  tbody tr {
    cursor: pointer;
    background: transparent;
    box-shadow: inset 0 0 0 #1e3a5f;
    transition: background 150ms cubic-bezier(0.22, 1, 0.36, 1), box-shadow 150ms ease;
  }
  tbody tr:hover,
  tbody tr:focus-within {
    background: linear-gradient(
      90deg,
      rgba(30, 58, 95, 0.14) 0%,
      rgba(30, 58, 95, 0.07) 45%,
      rgba(30, 58, 95, 0.015) 100%
    );
    box-shadow: inset 3px 0 0 #1e3a5f;
  }
  ${onPhone} {
    header {
      padding: 14px 16px 10px;
    }
    table {
      min-width: 0;
    }
    thead {
      display: none;
    }
    tbody tr {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 8px 12px;
      padding: 12px 16px;
    }
    tbody td,
    tbody td:first-child,
    tbody td:last-child {
      padding: 0;
    }
    tbody td:first-child {
      grid-column: 1 / -1;
    }
    tbody td[data-label]::before {
      content: attr(data-label);
      display: block;
      margin-bottom: 4px;
      font-family: 'Montserrat', sans-serif;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      color: #8c8c8c;
    }
  }
`;

export const RowButton = styled.button`
  border: none;
  background: none;
  padding: 0;
  font: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #262626;
  cursor: pointer;
  ${onPhone} {
    font-size: 14px;
  }
  &:focus-visible {
    outline: none;
  }
`;

export const RoleBody = styled.div`
  .rb-roles {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
    padding: 16px 20px;
    list-style: none;
    border-bottom: 1px solid #f0f0f0;
  }
  .rb-roles li {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    padding: 10px 11px;
  }
  .rb-roles strong {
    display: block;
    font-size: 13px;
    font-weight: 600;
  }
  .rb-roles small {
    display: block;
    font-size: 11px;
    color: #8c8c8c;
    margin-top: 3px;
    ${onPhone} {
      font-size: 12px;
    }
  }
  .rb-caps {
    padding: 16px 20px 20px;
  }
  .rb-caps ul {
    display: flex;
    flex-wrap: wrap;
    gap: 7px;
    margin: 0;
    padding: 0;
    list-style: none;
  }
  .rb-caps li {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    border: 1px solid #d9d9d9;
    border-radius: 999px;
    padding: 6px 12px;
    font-size: 12px;
    font-weight: 600;
    color: #595959;
  }
`;

export const Eyebrow = styled.h3`
  margin: 0 0 10px;
  font-family: 'Montserrat', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #8c8c8c;
  ${onPhone} {
    font-size: 12px;
  }
`;

export const TabBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
